import React from "react";
import cx from "classname";
import * as styles from "./styles.module.scss";

function SiteGutter({ children, className, light }) {
  return (
    <div className={cx(light ? styles.gutterLight : styles.gutter, className)}>
      {children}
    </div>
  );
}

SiteGutter.defaultProps = {
  light: true
};

export default SiteGutter;
